import { createIntegration } from '../reducer/createIntegration';

const createIntegrationActions = { ...createIntegration.actions };

export default createIntegrationActions;
